export default __webpack_public_path__ + "src/assets/QuickNode_Desktop.9e9565a9e2122875664a1cd2896b9746.svg";